var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home-container" }, [
    _c(
      "div",
      { staticClass: "hx-breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { "separator-class": "el-icon-arrow-right" } },
          [
            _c("el-breadcrumb-item", [_vm._v("首页")]),
            _c("el-breadcrumb-item", [_vm._v("供应系统")]),
            _c("el-breadcrumb-item", [_vm._v("运营管理")]),
            _c(
              "el-breadcrumb-item",
              { attrs: { to: { name: "promotionManage" } } },
              [_vm._v("优惠活动")]
            ),
            _c("el-breadcrumb-item", [_vm._v("活动详情")]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.detailLoading,
            expression: "detailLoading",
          },
        ],
        staticClass: "hx-form-container box-shadow",
      },
      [
        _c(
          "div",
          { staticStyle: { width: "50%" } },
          [
            _c(
              "el-form",
              {
                ref: "listForm",
                attrs: {
                  model: _vm.listParams,
                  rules: _vm.checkListParams,
                  "label-width": "150px",
                },
              },
              [
                _c("el-form-item", { attrs: { label: " " } }, [
                  _vm.status === 1
                    ? _c("h1", { staticStyle: { color: "grey" } }, [
                        _vm._v("未使用"),
                      ])
                    : _vm.status === 2
                    ? _c("h1", { staticStyle: { color: "orange" } }, [
                        _vm._v("已使用"),
                      ])
                    : _vm.status === 3
                    ? _c("h1", { staticStyle: { color: "red" } }, [
                        _vm._v("已过期"),
                      ])
                    : _vm._e(),
                ]),
                _c(
                  "el-form-item",
                  { attrs: { label: "活动名称：", prop: "name" } },
                  [
                    _c("el-input", {
                      attrs: { size: "small", placeholder: "请输入活动名称" },
                      model: {
                        value: _vm.listParams.name,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.listParams,
                            "name",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "listParams.name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "折扣率：", prop: "discount" } },
                  [
                    _c("el-input-number", {
                      attrs: { size: "small", min: 1, max: 100 },
                      model: {
                        value: _vm.listParams.discount,
                        callback: function ($$v) {
                          _vm.$set(_vm.listParams, "discount", $$v)
                        },
                        expression: "listParams.discount",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "活动商品：", prop: "promotionList" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          size: "small",
                          filterable: "",
                          clearable: "",
                          remote: "",
                          "reserve-keyword": "",
                          placeholder: "请输入参加活动的商品",
                          "remote-method": _vm.remoteMethod,
                        },
                        on: { change: _vm.goodsChanged },
                        model: {
                          value: _vm.listParams.goodsId,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.listParams,
                              "goodsId",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "listParams.goodsId",
                        },
                      },
                      _vm._l(_vm.goodsList, function (item) {
                        return _c("el-option", {
                          key: item.title,
                          attrs: { label: item.title, value: item.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "选中商品：" } },
                  _vm._l(_vm.categoryNameList, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticStyle: { "margin-top": "5px" } },
                      [
                        _c("div", { staticClass: "e-tag-div-style" }, [
                          _c("span", { staticClass: "e-tag-title" }, [
                            _vm._v(_vm._s(item.title) + "："),
                          ]),
                          _c(
                            "ul",
                            { staticClass: "e-tag-ul-style" },
                            _vm._l(
                              _vm.goodsCategory["categoryList_" + index],
                              function (item1, index1) {
                                return _c(
                                  "li",
                                  {
                                    key: index1,
                                    staticClass:
                                      "e-tag-inline e-tag e-tag-info e-tag-mini",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "el-tag-item-text" },
                                      [_vm._v(_vm._s(item1.title))]
                                    ),
                                    _c("i", {
                                      staticClass:
                                        "e-tag-item-close el-icon-circle-close",
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteItem(
                                            _vm.goodsCategory[
                                              "categoryList_" + index
                                            ],
                                            index1,
                                            index
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
                _c("date-components", {
                  staticStyle: { "margin-top": "10px" },
                  attrs: {
                    "start-prop": "startDate",
                    "end-prop": "endDate",
                    "start-date": _vm.listParams.startDate,
                    "end-date": _vm.listParams.endDate,
                    "date-type": "date",
                    "show-type": "both",
                    "label-name": "活动周期：",
                  },
                  on: {
                    "set-start-date": _vm.getStartDate,
                    "set-end-date": _vm.getEndDate,
                  },
                }),
                _c(
                  "el-form-item",
                  { attrs: { label: "优惠方式：" } },
                  [
                    _c(
                      "el-radio",
                      {
                        attrs: { label: 1 },
                        model: {
                          value: _vm.listParams.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.listParams, "type", $$v)
                          },
                          expression: "listParams.type",
                        },
                      },
                      [_vm._v("折扣优惠")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "small",
                          type: "primary",
                          disabled: _vm.isDisabled,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.confirm("listForm")
                          },
                        },
                      },
                      [_vm._v("确定")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.$router.push({ name: "promotionManage" })
                          },
                        },
                      },
                      [_vm._v("取消")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }